import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaEnvelope } from 'react-icons/fa';
import '../../styles/RegisterTrainerAndSchool.css';

const RegisterTrainerSuccess = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('auth');

    return (
        <div className="reg">
            <div className="reg__left-panel">
                <div className="reg__left-content">
                    <h2 className="reg__welcome-text">
                        {t('registrationSuccess.leftTitle')}
                        <span className="reg__welcome-highlight">{t('registrationSuccess.leftHighlight')}</span>
                    </h2>
                </div>
            </div>
            <div className="reg__right-panel" style={{ justifyContent: 'center' }}>
                <div className="reg__form-wrapper" style={{ textAlign: 'center', maxWidth: '520px' }}>
                    <div style={{
                        width: '72px',
                        height: '72px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1.5rem',
                        boxShadow: '0 8px 24px rgba(34, 197, 94, 0.3)',
                    }}>
                        <FaCheckCircle size={32} color="#ffffff" />
                    </div>

                    <h1 style={{
                        fontSize: '1.75rem',
                        fontWeight: '700',
                        color: '#333',
                        marginBottom: '1rem',
                        fontFamily: "'Montserrat', sans-serif",
                    }}>
                        {t('registrationSuccess.title')}
                    </h1>

                    <div style={{
                        background: '#f8f7ff',
                        borderRadius: '16px',
                        padding: '1.5rem',
                        marginBottom: '2rem',
                        border: '1px solid #eeedff',
                    }}>
                        <FaEnvelope size={20} color="#7269FF" style={{ marginBottom: '0.75rem' }} />
                        <p style={{
                            fontSize: '1rem',
                            color: '#555',
                            lineHeight: '1.6',
                            margin: 0,
                            fontFamily: "'Montserrat', sans-serif",
                        }}>
                            {t('registrationSuccess.message')}
                        </p>
                    </div>

                    <button
                        onClick={() => navigate('/')}
                        className="reg__submit-btn reg__submit-btn--final"
                        style={{ margin: '0 auto' }}
                    >
                        {t('registrationSuccess.goToLogin')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RegisterTrainerSuccess;
